<!-- Uploaded to: SVG Repo, www.svgrepo.com, Transformed by: SVG Repo Mixer Tools -->
<svg
	fill="currentColor"
	width="35px"
	height="35px"
	viewBox="0 0 32 32"
	version="1.1"
	xmlns="http://www.w3.org/2000/svg"
>
	<g id="SVGRepo_bgCarrier" stroke-width="0" />

	<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

	<g id="SVGRepo_iconCarrier">
		<title>search-pin</title>
		<path
			d="M30.531 29.469l-10.453-10.453c1.604-1.861 2.58-4.301 2.58-6.97 0-5.912-4.793-10.704-10.704-10.704s-10.704 4.793-10.704 10.704c0 5.912 4.793 10.704 10.704 10.704 0.016 0 0.032-0 0.048-0h-0.002c2.697-0.011 5.156-1.022 7.027-2.681l-0.011 0.010 10.453 10.453c0.136 0.136 0.324 0.22 0.531 0.22 0.415 0 0.751-0.336 0.751-0.751 0-0.207-0.084-0.395-0.22-0.531v0zM2.75 12c0-5.109 4.141-9.25 9.25-9.25s9.25 4.141 9.25 9.25c0 5.109-4.141 9.25-9.25 9.25v0c-5.106-0.006-9.244-4.144-9.25-9.249v-0.001zM11.982 4.814c-3.067 0.138-5.535 2.531-5.788 5.554l-0.002 0.022c0 2.235 4.345 7.497 5.216 8.529 0.138 0.163 0.343 0.265 0.572 0.266h0.001c0 0 0.001 0 0.001 0 0.228 0 0.432-0.102 0.569-0.263l0.001-0.001c0.877-1.033 5.253-6.295 5.253-8.531-0.265-3.053-2.745-5.448-5.812-5.576l-0.012-0zM11.984 17.261c-1.943-2.396-4.291-5.742-4.291-6.87 0.26-2.211 2.053-3.931 4.275-4.075l0.014-0.001c2.248 0.136 4.054 1.858 4.322 4.054l0.002 0.022c0 1.127-2.365 4.474-4.322 6.87zM12 7.825c-0 0-0 0-0.001 0-1.511 0-2.737 1.225-2.737 2.737s1.225 2.737 2.737 2.737c1.511 0 2.737-1.225 2.737-2.736v-0c-0.001-1.511-1.226-2.735-2.736-2.737h-0zM12 11.799c-0 0-0 0-0.001 0-0.683 0-1.237-0.554-1.237-1.237s0.554-1.237 1.237-1.237c0.683 0 1.237 0.554 1.237 1.237 0 0 0 0 0 0.001v-0c-0.001 0.682-0.554 1.235-1.236 1.236h-0z"
		/>
	</g>
</svg>
